import { useLocation, Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from 'constants/index.js';

import { useAuth } from 'services/hooks';

const ProtectedRoute = ({ allowedRoles }) => {
	const user = useAuth();
	const location = useLocation();

	if (allowedRoles && allowedRoles.includes(user?.roleId)) {
		return <Outlet />;
	} else if (user?.token) {
		return <Navigate to={ROUTES.UNAUTHORIZED} state={{ from: location }} replace />;
	}
	return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
};

export default ProtectedRoute;
